import {useCallback, useState} from 'react';

// Encapsulates the "warn before leaving an in-progress QA review batch" pattern.
// Returns a guardNavigation function: call it with the navigation you want to perform.
// If a batch is in progress, the navigation is deferred and isLeaveModalOpen becomes true;
// otherwise the navigation runs immediately and guardNavigation returns false (not blocked).
function useLeaveQAReviewGuard({hasStartedCurrentBatch}) {
    const [pendingLeaveAction, setPendingLeaveAction] = useState(null); // null | () => void

    const guardNavigation = useCallback((onConfirm) => {
        if (!hasStartedCurrentBatch) return false;
        setPendingLeaveAction(() => onConfirm ?? null);
        return true;
    }, [hasStartedCurrentBatch]);

    const confirmLeave = useCallback(() => {
        const action = pendingLeaveAction;
        setPendingLeaveAction(null);
        action?.();
    }, [pendingLeaveAction]);

    const cancelLeave = useCallback(() => {
        setPendingLeaveAction(null);
    }, []);

    return {
        isLeaveModalOpen: pendingLeaveAction !== null,
        guardNavigation,
        confirmLeave,
        cancelLeave,
    };
}

export default useLeaveQAReviewGuard;
